<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
  <h2>{{payeeSector.id?payeeSector.name:('PAYEE-SECTOR.ADD' | translate)}}</h2>

  <div class="col-xs-12">

    <div [hidden]="submitted">
      <form (ngSubmit)="onSubmit()" #payeeSectorForm="ngForm">
        <button type="submit" class="btn btn-primary" style="float: right;" [disabled]="!payeeSectorForm.form.valid">{{'CURRENCY.SAVE' | translate}}
        </button>
        <button class="btn btn-primary" style="float: right; margin-right: 10px;" (click)="goToList()">{{'CURRENCY.CANCEL' | translate}}</button>

        <br/>
        <br/><br/>
        <div class="form-group">
          <label for="name">{{'PAYEE-SECTOR.NAME' | translate}}</label>
          <input type="text" class="form-control" id="name" [(ngModel)]="payeeSector.name" name="name" #name="ngModel" required>
          <div [hidden]="name.valid || name.pristine" class="alert alert-danger">
            {{'CURRENCY.NAME_REQ' | translate}}
          </div>
        </div>

        <div class="form-group">
          <label for="code">{{'PAYEE-SECTOR.CODE' | translate}}</label>
          <input type="text" class="form-control" id="code" [(ngModel)]="payeeSector.code" name="code" #code="ngModel" required>
          <div [hidden]="code.valid || code.pristine" class="alert alert-danger">
            {{'CURRENCY.CODE_REQ' | translate}}
          </div>
        </div>

      </form>
    </div>
    <br/>
    <label for="code">{{'PAYEE-SECTOR.SUB_SECTORS' | translate}}</label>
    <table class="styled-table">
      <thead>
        <tr>
          <th>{{'PAYEE-SECTOR.NAME' | translate}}</th>
          <th>{{'PAYEE-SECTOR.CODE' | translate}}</th>
        </tr>
      </thead>
      <tbody>
        @for (activity of payeeSector.activities; track activity; let i = $index) {
          <tr>
            <td>{{activity.name}}</td>
            <td>{{activity.code}}</td>
          </tr>
        }
        <!-- and so on... -->
      </tbody>
    </table>
  </div>
</div>